import ProxyBase from '../../../../../../core/proxies/ProxyBase'

class CategoryProxy extends ProxyBase {
  getCategoryLegalFormAdjusted(params) {
    return this.get('legalFormAdjusted', params)
  }

  getCompanyStatus(params) {
    return this.get('ActiveStatus', params, undefined, true)
  }
}

export default new CategoryProxy('Category/')
